const VIETEL_PHONE_NUMBER_PREFIX = [
  '086',
  '096',
  '097',
  '098',
  '032',
  '033',
  '034',
  '035',
  '036',
  '037',
  '038',
  '039',
];

const VINA_PHONE_NUMBER_PREFIX = [
  '088',
  '091',
  '094',
  '083',
  '084',
  '085',
  '081',
  '082',
];

const MOBI_PHONE_NUMBER_PREFIX = [
  '089',
  '090',
  '093',
  '070',
  '079',
  '077',
  '076',
  '078',
];

const VIETNAMMOBILE_PHONE_NUMBER_PREFIX = ['092', '056', '058'];

const GMOBILE_PHONE_NUMBER_PREFIX = ['099', '059'];

const ITELECOM_PHONE_NUMBER_PREFIX = ['087'];

const VIETNAM_PHONE_NUMBER_PREFIX = [
  ...VIETEL_PHONE_NUMBER_PREFIX,
  ...VINA_PHONE_NUMBER_PREFIX,
  ...MOBI_PHONE_NUMBER_PREFIX,
  ...VIETNAMMOBILE_PHONE_NUMBER_PREFIX,
  ...GMOBILE_PHONE_NUMBER_PREFIX,
  ...ITELECOM_PHONE_NUMBER_PREFIX,
];

export default {
  VIETNAM_PHONE_NUMBER_PREFIX,
};
